module.exports = __webpack_public_path__ + "static/media/1542319096912942253945 - Citizen Datasteward.19a45c85.jpg";